import axios from "axios";

const baseURL = "https://challenge.thef2e.com/api/thef2e2019/stage6/";
const headers = {
  Authorization: "Bearer SuH6SdtjB06F2N2052ncZh7fO14D3NltWa478ZmnS32tdqIzv7YsAUanItfC",
  accept: 'application/json'
};

export default {
  getAllRoomsInfo() {
    return axios({
      baseURL,
      headers,
      method: 'get',
      url: `rooms`
    })
  },
  getRoomByID(id) {
    return axios({
      baseURL,
      headers,
      method: 'get',
      url: `room/${id}`
    })
  },
  makeRoomReservation(id, params) {
    return axios({
      baseURL,
      headers,
      method: 'post',
      url: `room/${id}`,
      params
    })
  },
  deleteAllReservation() {
    return apiClient.delete(`rooms`);
  }
};